import type { AppState } from 'state/model';

export function userCanTrade(state: AppState) {
  return state.clientWorkspace.tradingDisabled === false;
}
